<h5 class="mb-2 font-medium">{{ 'discover.card.headline' | transloco }}</h5>
<discover-nav [(type)]="cardType" />
@switch (cardType) {
  @case (DiscoverCardType.Latest) {
    <discover-latest (openDetails)="openDetails($event, DiscoverCardType.Latest)" [teasers]="facade.todayTeaser$ | async" />
  }
  @case (DiscoverCardType.Megatrends) {
    <discover-megatrends (openDetails)="openDetails($event, DiscoverCardType.Megatrends)" [megatrends]="facade.megatrends$ | async" />
  }
  @case (DiscoverCardType.KnowHow) {
    <discover-know-how (openDetails)="openDetails($event, DiscoverCardType.KnowHow)" [knowHow]="facade.knowHow$ | async" />
  }
  @case (DiscoverCardType.More) {
    <discover-more (openDetails)="openDetails($event, DiscoverCardType.More)" [links]="facade.listsAndLinks$ | async" />
  }
}
<ng-template #modal let-modal>
  <discover-article [cardType]="cardType" (handleClose)="modal.dismiss()" />
</ng-template>
